<template>
  <div class="showTheLogin">
    <div class="loginCent">
      <nav>
        <div class="hiddenLoginBtn">
          <a class="el-icon-close" @click="hiddenLoginBtn" />
        </div>
      </nav>
      <div class="loginForm">
        <!-- <div class="loginTit" v-text="isRegistered == '1' ? '注册' : '登录'"></div> -->
        <div class="loginTitle">
          <div class="title"  v-text="isRegistered !== '1' ? $t('user.login') : $t('user.register')"></div>
          <div class="content">
            <span v-text="isRegistered === '1' ? $t('user.haveAccount') : $t('user.firstUse')"></span>
            <u @click="registered" v-text="isRegistered === '1' ? $t('user.loginNow') : $t('user.register')"></u></div>
        </div>
        <div class="loginFormBox">
          <!-- 登录类型切换 -->
          <div class="loginTypeSwitch">
            <div
              class="loginTypeItem"
              :class="{ active: loginType === 'phone' }"
              @click="switchLoginType('phone')"
            >
              {{ $t('user.phoneLogin') }}
            </div>
            <div
              class="loginTypeItem"
              :class="{ active: loginType === 'email' }"
              @click="switchLoginType('email')"
            >
              {{ $t('user.emailLogin') }}
            </div>
          </div>

          <div class="inputBox">
            <el-input v-model="userName" :placeholder="loginType === 'phone' ? $t('user.enterPhone') : $t('user.enterEmail')">
              <template slot="prepend">
                <span class="icon iconfont">{{ loginType === 'phone' ? '&#xe62f;' : '&#xe63a;' }}</span>
              </template>
            </el-input>
          </div>
          <div class="inputBox">
            <el-input
              v-model="verificationCode"
              :placeholder="$t('user.enterCode')"
              @keyup.enter.native="login"
            >
              <template slot="prepend">
                <span class="icon iconfont">&#xe62e;</span>
              </template>
            </el-input>
            <span v-show="codeShow" class="codeBtn" @click="getCode">{{ $t('user.getCodeShort') }}</span>
            <span v-show="!codeShow" class="codeBtn codeCount">{{ $t('user.retrieve')}} ({{codeCountNum}}s)</span>
          </div>
          <div class="noLogin" :class="{registered: isRegistered === '1'}" >
            <el-checkbox v-show="isRegistered === '2'" v-model="isNoLogin">{{$t('user.rememberMe')}}</el-checkbox>
            <span ></span>
          </div>
          <el-button class="loginBtn"
            @click="login"
            :loading="loadingLogin"
          >{{ isRegistered === '1' ?  $t('user.register') : $t('user.loginNow') }}</el-button>
        </div>
        <div class="loginProtocol" v-if="isRegistered === '1'">
          <el-checkbox v-model="haveRead"></el-checkbox>
          <span>{{ $t('user.agreement') }}</span>
          <span @click="readAgreement">《 {{ $t('user.serviceAgreement') }} 》</span>
        </div>
      </div>
    </div>
    <el-dialog
      :title="$t('user.serviceAgreement')"
      :visible.sync="dialogAgreement"
      width="50%">
      {{ $t('user.serviceAgreement') }}
    </el-dialog>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
import store from '@/store/index.js'
import i18n from '@/config/lang'
import {
  getTheCode,
  login
} from '@/api/login.js'
import {
  getUserInfo
} from '@/api/user/user.js'
export default {
  name: 'login',
  i18n,
  data () {
    return {
      userName: '',
      verificationCode: '',
      isNoLogin: false,
      haveRead: false,
      codeShow: true,
      codeCountNum: '',
      dialogAgreement: false,
      isRegistered: '2',
      loadingLogin: false,
      loginType: 'phone' // Add this line
    }
  },
  methods: {
    async getUserInfoData () {
      const response = await getUserInfo()
      const res = response.data
      if (res.code === '200') {
        store.commit('SET_USERINFO', res.data)
        this.userInfoData = res.data
      }
    },
    async getCode () {
      const TIME_COUNT = 120
      let reg = ''

      if (this.loginType === 'phone') {
        reg = /^1[13456789]\d{9}$/
        if (!reg.test(this.userName)) {
          this.$message({
            message: this.$t('common.invalidPhoneFormat'),
            type: 'error',
            customClass: 'messageZindex',
          })
          return
        }
      } else if (this.loginType === 'email') {
        reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!reg.test(this.userName)) {
          this.$message({
            message: '请输入有效的邮箱地址',
            type: 'error',
            customClass: 'messageZindex',
          })
          return
        }
      }

      const params = this.loginType === 'phone'
        ? { phone: this.userName, codeType: this.loginType }
        : { email: this.userName, codeType: this.loginType }

      const response = await getTheCode(params)
      const res = response.data
      if (res.code === '200') {
        if (!this.timer) {
          this.codeCountNum = TIME_COUNT
          this.codeShow = false
          this.timer = setInterval(() => {
            if (this.codeCountNum > 0 && this.codeCountNum <= TIME_COUNT) {
              this.codeCountNum--
            } else {
              this.codeShow = true
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        }
        this.$message({
          message: this.$t('common.getCodeSuccess'),
          type: 'success',
          customClass: 'messageZindex'
        })
      } else {
        this.$message({
          message: res.message,
          type: 'warning',
          customClass: 'messageZindex'
        })
      }
    },
    // 阅读协议
    readAgreement () {
      this.dialogAgreement = true
    },
    login () {
      let reg = ''

      if (this.loginType === 'phone') {
        reg = /^1[13456789]\d{9}$/
        if (!reg.test(this.userName)) {
          this.$message({
            message: this.$t('common.invalidPhoneFormat'),
            type: 'error',
            customClass: 'messageZindex'
          })
          return
        }
      } else if (this.loginType === 'email') {
        reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!reg.test(this.userName)) {
          this.$message({
            message: '请输入有效的邮箱地址',
            type: 'error',
            customClass: 'messageZindex'
          })
          return
        }
      }

      if (this.verificationCode === '') {
        this.$message({
          message: this.$t('user.enterCode'),
          type: 'warning',
          customClass: 'messageZindex'
        })
        return
      }
      if (this.isRegistered === '2') {
        this.getLogin()
      } else if (this.haveRead) {
        this.getLogin()
      } else {
        this.$message({
          message: this.$t('user.confirmServiceAgreement'),
          type: 'warning',
          customClass: 'messageZindex'
        })
      }
    },
    async getLogin () {
      this.loadingLogin = true
      const params = this.loginType === 'phone'
        ? {
            phone: this.userName,
            verificationCode: this.verificationCode,
            type: this.isRegistered,
            terminal: 5,
            codeType: this.loginType
          }
        : {
            email: this.userName,
            verificationCode: this.verificationCode,
            type: this.isRegistered,
            terminal: 5,
            codeType: this.loginType
          }

      const response = await login(params)
      const res = response.data
      if (res.code === '200') {
        if (this.isNoLogin) {
          Cookie.set('token', res.data.token, { expires: 7 })
        } else {
          Cookie.set('token', res.data.token, { expires: 1 })
        }
        this.getUserInfoData()
        this.$message({
          message: this.$t('user.loginSuccess'),
          type: 'success',
          customClass: 'messageZindex'
        })
        store.commit('SHOW_LOGIN')
        store.commit('IS_LOGIN', true)
        location.reload()
      } else {
        this.$message({
          message: res.message,
          type: 'warning',
          customClass: 'messageZindex'
        })
      }
      this.loadingLogin = false
    },
    registered () {
      this.codeShow = true
      clearInterval(this.timer)
      this.timer = null
      this.userName = ''
      this.verificationCode = ''
      if (this.isRegistered === '1') {
        this.isRegistered = '2'
      } else {
        this.isRegistered = '1'
      }
    },
    // 切换登录类型
    switchLoginType (type) {
      this.loginType = type
      this.userName = ''
      this.verificationCode = ''
      this.codeShow = true
      clearInterval(this.timer)
      this.timer = null
    },

    // 关闭登录
    hiddenLoginBtn () {
      store.commit('SHOW_LOGIN')
    }
  }
}
</script>

<style lang="scss" scoped>
.showTheLogin {
  // height: 100vh;
  // min-height: 768px;
  position: fixed;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  .loginCent {
    // background: url('../../assets/images/beijing.png') no-repeat;
    // flex-grow: 1;
    // background-size: cover;
    width: 500px;
    height: 100%;
    min-height: 768px;
    padding: 20px 50px;
    float: right;
    background-color: #ffffff;
    animation: showRight .5s;
    animation-fill-mode:forwards;
    -webkit-animation-fill-mode:forwards;
    nav{
      margin-bottom: 85px;
      .hiddenLoginBtn{
        a{
          float: right;
        }
      }
    }
    .loginForm {
      width: 500px;
      height: 100%;
      background: #ffffff;
      .loginTitle{
        font-family: Microsoft YaHei;
        color: #333333;
        .title{
          font-size: 36px;
        }
        .content{
          margin: 10px 0;
          font-size: 14px;
          u{
            color: #C5AA7B;
            cursor: pointer;
          }
        }
      }
      .loginFormBox {
        .inputBox {
          position: relative;
          .el-input{
            .iconfont{
              font-size: 32px;
              padding: 0 10px;
            }
          }
          >>> .el-input__inner {
            height: 70px;
            background: #F3F4F5;
            border-radius: 0px;
            font-size: 20px;
            padding-left: 5px;
          }
          &:nth-child(2) {
            margin: 60px 0 20px 0;
          }
          .codeBtn {
            width: 120px;
            height: 50px;
            background: $mainGlod;
            border-radius: 0;
            display: block;
            line-height: 54px;
            text-align: center;
            position: absolute;
            right: 5px;
            bottom: 10px;
            cursor: pointer;
          }
          .codeCount {
            color: #999999;
          }
        }
        .noLogin {
          color: #333333;
          font-size: 18px;
          margin:20px 0 60px 0;
          height: 30px;
          align-items: center;
          display: flex;
          justify-content: space-between;
          >>> .el-checkbox__label {
            font-size: 16px;
            color: #333333;
            font-weight: 400;
          }
          span {
            cursor: pointer;
            font-size: 16px;
            text-decoration: underline;
            color: #666666;
          }
        }
        .registered {
          justify-content: flex-end;
        }
        .loginBtn {
          width: 100%;
          height: 70px;
          background: #333333;
          border-radius: 0;
          border: 1px solid #333333;
          text-align: center;
          font-size: 20px;
          color: $mainGlod;
          cursor: pointer;
          &:hover{
            border: 1px solid $mainGlod;
          }
        }
      }
      .loginProtocol {
        padding: 0 60px;
        display: flex;
        align-items: center;
        height: 80px;
        line-height: 80px;
        border-top: 1px solid #EEEEEE;
        span {
          margin-left: 10px;
        }
        span:nth-child(3) {
          color: #426BEA;
          cursor: pointer;
        }
      }
      >>> .el-checkbox__inner {
        width: 20px;
        height: 20px;
        &:after {
          height: 10px;
          left: 7px;
          width: 4px;
        }
      }
    }
  }
  >>> .el-dialog__body {
    max-height: 500px;
    min-height: 300px;
    overflow: auto;
  }
}
.hiddenLogin {
  display: none;
}
@keyframes showRight {
  from {
    width: 560px;
    opacity: 0;
  }
  to {
    width: 600px;
    opacity: 1;
    display: block;
  }
}
.loginTypeSwitch {
  display: flex;
  margin-bottom: 30px;
  border-bottom: 1px solid #EEEEEE;

  .loginTypeItem {
    flex: 1;
    text-align: center;
    padding: 15px 0;
    cursor: pointer;
    font-size: 16px;
    color: #999999;
    border-bottom: 2px solid transparent;
    transition: all 0.3s ease;

    &.active {
      color: #333333;
      border-bottom-color: #C5AA7B;
    }

    &:hover {
      color: #666666;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue